import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    width: '100%',
    background: theme.palette.background.paper,
    borderRadius: '24px',
    padding: '26px 24px',
    marginTop: '20px',
    textAlign: 'center',
    fontSize: '18px',
    color: '#111111',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px'
    }
  },
  link: {
    textDecoration: 'none'
  }
}))
